import Chip from '@material-ui/core/Chip';
import styled from 'styled-components';

export default styled(Chip)`
  && {
    height: 40px;
    border-radius: 20px;

    .MuiChip-label {
      padding-right: 16px;
      padding-left: 16px;
    }
  }
`;
